import ApiClient from './ApiClient';

class ComplaintsAPI extends ApiClient {
    constructor() {
        super('complaints', { accountScoped: true });
    }

    get(params) {
        return axios.get(`${this.url}`, {
            params
        });
    }

    status() {
        return axios.get(`${this.url}/status`)
    }

    update(id, data) {
        return axios.put(`${this.url}/${id}`, data);
    }

    audit(id) {
        return axios.get(`${this.url}/${id}/audits`)
    }

    summary(params) {
        return axios.get(`${this.url}/summary`, {
            params
        });
    }

    report(params, config = {}) {
        return axios.get(`${this.url}/report`, {
            params,
            ...config,
        });
    }

    wo_summary(params) {
        return axios.get(`${this.url}/wo_summary`, {
            params,
        });
    }

    wo_report(params) {
        return axios.get(`${this.url}/wo_report`, {
            params,
        });
    }

    wo_global(params) {
        return axios.get(`${this.url}/wo_global`, {
            params,
        });
    }
}


export default new ComplaintsAPI()